<script>
// TODO: Part 1 - import apiSvc from "@/services/api"; does not work here
import axios from "axios";
import { mapGetters } from "vuex";
import { addSeconds } from "date-fns";
export default {
    name: "HandleServerTime",
    data() {
        return {
            serverTimeInitialized: false,
            serverTimeInterval: null,
            refetchInterval: null,
            currentTimeISO: null
        };
    },
    computed: {
        ...mapGetters(["apiBaseURL", "idToken"])
    },
    created() {
        this.initServerTime();

        // Fetching the server time may take a second
        // let's initialize `window.MgServerTime` with visitors local time
        // in case other code tries to use `window.MgServerTime` before `getServerTime` and subsequent init completes
        if (!this.serverTimeInitialized) {
            window.MgServerTime = new Date();
        }

        // window.setInterval does not consistently run every X seconds depending on..
        // ..acitivity in javascripts main thread.
        // It is possible for `serverTimeInterval` to fall out of sync with true server time
        // so we will refresh `serverTimeInterval` every minute
        const ONE_MINUTE = 60000;
        this.refetchInterval = window.setInterval(
            this.initServerTime,
            ONE_MINUTE
        );
    },
    beforeDestroy() {
        this.clearServerTimeInterval();
        window.clearInterval(this.refetchInterval);
    },
    methods: {
        getServerTime() {
            return new Promise((resolve, reject) => {
                // TODO: Part 2 - this should come from API service
                const baseURL = this.apiBaseURL;
                const apiClient = axios.create({
                    baseURL,
                    withCredentials: false,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    }
                });
                apiClient
                    .get(`/server-time`, {
                        headers: {
                            Authorization: `bearer ${this.idToken}`
                        }
                    })
                    .then(response => {
                        if (response.data && response.data.currentTimeISO) {
                            this.currentTimeISO = response.data.currentTimeISO;
                        }
                        return resolve();
                    })
                    .catch(error => {
                        return reject(error);
                    });
            });
        },
        clearServerTimeInterval() {
            window.clearInterval(this.serverTimeInterval);
        },
        handleInterval() {
            this.clearServerTimeInterval();

            if (!this.currentTimeISO) return;

            this.serverTimeInterval = window.setInterval(() => {
                // Setting on window not storing Vuex
                // this is because we dont want to call a mutation every second,
                // doing so would pollute the mutations list in vue devtools
                if (this.serverTimeInitialized) {
                    window.MgServerTime = addSeconds(window.MgServerTime, 1);
                } else {
                    window.MgServerTime = new Date(this.currentTimeISO);
                }

                this.serverTimeInitialized = true;
            }, 1000);
        },
        initServerTime() {
            this.getServerTime()
                .then(() => {
                    this.serverTimeInitialized = false;
                    this.handleInterval();
                })
                .catch(error => {
                    console.error(error);
                });
        }
    },
    render(h) {
        return h(null);
    }
};
</script>